<template>
  <div class="profile-layout">
    <div v-if='isServiceProviderAdmin'>
      <div class="profile-header">
        <el-radio-group v-model="activeTab" size="small">
          <el-radio-button
            class="tab-button"
            v-for="tab in tabs"
            :label="tab.label"
            :key="tab.label"
          />
        </el-radio-group>
      </div>
      <div v-if='isAdminProfileTab' class="customer-profile">
        <ServiceProviderWorkerProfile/>
      </div>
      <div v-else class="customer-profile">
        <ServiceProviderCompanyProfile/>
      </div>
    </div>
    <div v-else-if='isServiceProviderFreelancer'>
      <ServiceProviderFreelancerProfile/>
    </div>
    <div v-else>
      <ServiceProviderWorkerProfile/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ServiceProviderWorkerProfile from '@/views/sp-profile/ServiceProviderWorkerProfile.vue';
import ServiceProviderCompanyProfile from '@/views/sp-profile/ServiceProviderCompanyProfile.vue';
import {
  LOAD_SP_COMPANY_CERTIFICATES,
  LOAD_SP_COMPANY_EMPLOYEES_AMOUNT,
} from '@/store/spCompanyRegistration/actionTypes';
import {
  LOAD_SERVICE_PROVIDER_COMPANY_FULL_REGIONS_OPTIONS,
  LOAD_SERVICE_PROVIDER_COMPANY_FULL_SERVICES_OPTIONS,
  LOAD_SERVICE_PROVIDER_COMPANY_PROFILE_DETAILS,
  LOAD_SERVICE_PROVIDER_FREELANCER_PROFILE,
  LOAD_SERVICE_PROVIDER_WORKER_PROFILE,
} from '@/store/user/actionTypes';
import ServiceProviderFreelancerProfile from '@/views/sp-profile/ServiceProviderFreelancerProfile.vue';
import { LOAD_SERVICES } from '@/store/spFreelancerRegistration/actionTypes';

export default {
  name: 'ServiceProviderProfile',
  components: {
    ServiceProviderFreelancerProfile,
    ServiceProviderCompanyProfile,
    ServiceProviderWorkerProfile,
  },
  async created() {
    await this.$store.dispatch(LOAD_SERVICES);
    await this.$store.dispatch(LOAD_SP_COMPANY_CERTIFICATES);
    await this.$store.dispatch(LOAD_SERVICE_PROVIDER_COMPANY_FULL_SERVICES_OPTIONS);
    await this.$store.dispatch(LOAD_SP_COMPANY_EMPLOYEES_AMOUNT);
    await this.$store.dispatch(LOAD_SERVICE_PROVIDER_COMPANY_FULL_REGIONS_OPTIONS);
    await this.$store.dispatch(LOAD_SERVICE_PROVIDER_WORKER_PROFILE);
    await this.$store.dispatch(LOAD_SERVICE_PROVIDER_COMPANY_PROFILE_DETAILS);
    if (this.isServiceProviderFreelancer) {
      await this.$store.dispatch(LOAD_SERVICE_PROVIDER_FREELANCER_PROFILE);
    }
  },
  data() {
    return {
      serviceProviderProfile: {},
      tab: this.$t('service.provider.admin.edit.user.profile.tab'),
    };
  },
  computed: {
    ...mapGetters(['profile']),
    userRoles() {
      return this.profile?.roles?.map(role => role.name) || [];
    },
    isServiceProviderFreelancer() {
      return this.userRoles.includes('SPFreelancer');
    },
    isServiceProviderAdmin() {
      return this.userRoles.includes('SPAdmin');
    },
    isAdminProfileTab() {
      return this.activeTab === this.$t('service.provider.admin.edit.user.profile.tab');
    },
    companyProfileTab() {
      return {
        label: this.$t('service.provider.company.edit.profile.tab'),
      };
    },
    adminProfileTab() {
      return {
        label: this.$t('service.provider.admin.edit.user.profile.tab'),
      };
    },
    tabs() {
      return [this.adminProfileTab, this.companyProfileTab];
    },
    activeTab: {
      set(tab) {
        this.tab = tab;
      },
      get() {
        return this.tab;
      },
    },
  },
};
</script>

<style lang='scss'>
@import '~@/assets/styles/design-system';

.profile-layout {
  display: flex;
  flex-direction: column;
  margin-left: 4%;
  margin-top: 3%;
}

.customer-profile {
  flex: 1;
  margin-right: 4%;
}

.tab-button {
  color: var(--text-tertiary);
  font-family: $font-family-regular;
  font-size: $font-size-base;
  line-height: $font-size-base;
  text-align: center;
}
</style>
